// Self Exclusion
import { ResponsibleApi } from '@atlas/core';

import { getSelfRegulationFormattedFields, handleFormSubmit } from 'common/utils';
import { realityCheckVariants } from 'src/common/constants';

export const selfExclusionForm = {
  fields: [
    {
      component: 'SELECT',
      name: 'period',
      number: 0,
      options: [
        {
          text: '1 day',
          value: 'DAYS_1',
        },
        {
          text: '7 days',
          value: 'DAYS_7',
        },
        {
          text: '30 days',
          value: 'DAYS_30',
        },
        {
          text: 'forever',
          value: 'FOREVER',
        },
      ],
      rules: [],
      text: 'Exclusion period',
      value: 'DAYS_1',
    },
  ],
  name: 'selfExclusion',
};

// Reality Check
export const realityCheckForm = {
  fields: [
    {
      component: 'SELECT',
      name: 'period',
      options: realityCheckVariants,
      rules: [],
      text: 'Check period',
    },
  ],
  name: 'realityCheck',
};
export const onSetRealityCheckSubmit = handleFormSubmit(
  ResponsibleApi.setRealityCheckSettings.bind(ResponsibleApi),
);

// Self regulation Loss Limits
export const onSetLostLimitsSubmit = async (formData, actions, spentType) =>
  handleFormSubmit(
    ResponsibleApi.setClientLossLimits.bind(ResponsibleApi),
    getSelfRegulationFormattedFields.bind(null, spentType),
  )(formData, actions);

// Self regulation Deposit limits
export const onSetDepositLimitsSubmit = handleFormSubmit(
  ResponsibleApi.setClientDepositLimits.bind(ResponsibleApi),
  getSelfRegulationFormattedFields.bind(null, null),
);
